// ── Cargar un módulo que se pide tarde, con una build que puede haber cambiado ──
//
// La aplicación se sirve como chunks con hash en el nombre. Cuando se publica
// una versión, los archivos viejos dejan de existir; una pestaña que quedó
// abierta desde antes sigue pidiendo los nombres viejos. El primer `import()`
// que ocurre después —el modo de voz de Evo Brain es el único que hay— falla
// con "Failed to fetch dynamically imported module", que no le dice nada a
// nadie. Eduardo, el 2026-09-16, con esa ventana abierta hacía horas.
//
// Lo que corresponde ahí no es un mensaje de error: es recargar. La página se
// vuelve a pedir, llega el index.html nuevo con los hashes nuevos, y lo que se
// estaba por hacer se puede hacer. Se recarga UNA vez por versión —la marca
// vive en sessionStorage— para que un fallo real (sin red, el archivo caído de
// verdad) no deje el navegador dando vueltas.

const MARCA = 'evo:recarga-por-modulo';

/** ¿El fallo es "ese archivo ya no está", o es otra cosa? */
export function esModuloQueYaNoEsta(err: unknown): boolean {
  const msg = err instanceof Error ? `${err.name}: ${err.message}` : String(err);
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload/i.test(msg);
}

export async function cargarModulo<T>(cargar: () => Promise<T>): Promise<T> {
  try {
    return await cargar();
  } catch (err) {
    if (!esModuloQueYaNoEsta(err)) throw err;
    if (recargarUnaVez()) {
      // La recarga ya está pedida; devolver una promesa que nunca resuelve
      // evita que el llamador dibuje un error que va a durar un parpadeo.
      return await new Promise<T>(() => undefined);
    }
    throw err;
  }
}

/** true si se pidió la recarga; false si ya se había intentado y no funcionó. */
export function recargarUnaVez(): boolean {
  try {
    if (sessionStorage.getItem(MARCA)) return false;
    sessionStorage.setItem(MARCA, '1');
  } catch {
    // Sin sessionStorage (modo privado estricto) se recarga igual: el riesgo de
    // un bucle es menor que el de dejar la aplicación sin poder cargar nada.
  }
  window.location.reload();
  return true;
}

/** Al arrancar con la build nueva, la marca se limpia: la próxima vez vuelve a poder recargar. */
export function limpiarMarcaDeRecarga(): void {
  try { sessionStorage.removeItem(MARCA); } catch { /* da igual */ }
}
